import { ReactNode } from 'react'

import Grid from '@mui/material/Grid'

import styles from './HomepageContainer.module.css'

const HomepageContainer = ({ children }: { children: ReactNode }) => <Grid className={styles.wrapper} id="homescreen">{children}</Grid>

export default HomepageContainer